import { useState } from 'react';
import { AddDirectoriesTable } from '@/widgets/DirectoriesWidgets/AddDirectoriesTable';

import { DirectoryDTO } from '@/types/api-types';

import IconMobileLogo from '@/assets/svg/icon-add-mobile.svg?react';

import { useIsMobile } from '@/hooks/use-mobile';

import { Button } from '@/components/ui/button';
import { AddOrEditDirectoriesDialog } from '@/components/AddOrEditDirectoriesDialog';

import { useApiManagerStore } from '@/stores/apiManagerStore';

export function AddDirectoriesTab() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingDir, setEditingDir] = useState<DirectoryDTO | null>(null);
  const { directories, createDirectory, updateDirectory } =
    useApiManagerStore();
  const [isLoading, setIsLoading] = useState(false);

  const isMobile = useIsMobile();

  const handleAddDir = async (dir: DirectoryDTO) => {
    setIsLoading(true);
    try {
      await createDirectory(dir);
      setIsLoading(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
      setDialogOpen(false);
    }
  };

  const handleEditDir = async (dir: DirectoryDTO) => {
    setIsLoading(true);
    try {
      await updateDirectory(dir.uuid, dir);
    } catch (error) {
    } finally {
      setIsLoading(false);
      setDialogOpen(false);
    }
  };
  return (
    <div className="flex h-full flex-col rounded-md bg-white shadow-sm">
      <div className="flex items-center justify-between border-b pb-2 pl-8 pr-[22px] pt-4">
        <h2 className="text-2xl font-medium text-primary">Список дирекцій</h2>
        {isMobile ? (
          <button
            className="rounded-md text-white"
            onClick={() => setDialogOpen(true)}
          >
            <IconMobileLogo className="h-[34px] w-[34px] fill-primary" />
          </button>
        ) : (
          <Button
            className="h-[50px] w-[150px] rounded-md bg-primary text-white"
            onClick={() => setDialogOpen(true)}
          >
            Додати дирекцію
          </Button>
        )}
      </div>

      <div className="flex-grow overflow-auto">
        <AddDirectoriesTable
          data={directories}
          onEdit={(dir) => {
            setEditingDir(dir);
            setDialogOpen(true);
          }}
          isLoading={isLoading}
        />
      </div>

      <AddOrEditDirectoriesDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        editingDirectories={editingDir}
        onClose={() => setEditingDir(null)}
        onAdd={handleAddDir}
        onEdit={handleEditDir}
      />
    </div>
  );
}
